import React from 'react';
import { Link } from 'react-router-dom';
import { HOME_EXPERIENCE_CARDS } from '../../data/bookingExperienceData';
import ExperienceCard from './ExperienceCard';
import '../../styles/booking-experience.scss';

function HomeExperienceBand() {
	return (
		<section className="home-experience-band" aria-labelledby="home-experience-title">
				<div className="home-experience-band__inner">
					<h2 id="home-experience-title" className="home-experience-band__title">
						How to book
					</h2>
					<p className="home-experience-band__all-link-wrap">
						<Link to="/book-experiences" className="home-experience-band__all-link">All options →</Link>
					</p>
					<div className="home-experience-band__grid home-experience-band__grid--booking">
						{HOME_EXPERIENCE_CARDS.map((card) => (
							<ExperienceCard key={card.id} card={card} />
						))}
					</div>
				</div>
		</section>
	);
}

export default HomeExperienceBand;
